import React from 'react';
import HelpDesk from '../components/HelpDesk';
import Navbar from '../components/Navbar';

const HelpDeskPage = () => (
  <>
    <Navbar />
    <HelpDesk />
  </>
);

export default HelpDeskPage;
